export const EMPLOYEE_OFFBOARDING_DATEPICKER = 'EMPLOYEE_OFFBOARDING_DATEPICKER'
